// extracted by mini-css-extract-plugin
export default {"logo":"Logo__logo--hru","isCenter":"Logo__isCenter--Xgr","logoLink":"Logo__logoLink--2yB","container":"Logo__container--29w","icon":"Logo__icon--1er"};